import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { SquareCopySource } from 'app/model/pipeline/copysource/square.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SquareCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class SquareCopySourceAdapter extends CopySourceAdapter<SquareCopySource, Model.SquareSource> {
    protected override async _toResource(copySource: SquareCopySource): Promise<Model.SquareSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(SquareCopySource).name);
    }

    protected override async _toModel(
        resource: Model.SquareSource,
        copyActivity: CopyActivity
    ): Promise<SquareCopySource> {
        return this._toTabularModel(resource, copyActivity, SquareCopySource.MODEL);
    }
}
